import { render } from "./ClientInventarioProductos.vue?vue&type=template&id=222da6eb&scoped=true"
import script from "./ClientInventarioProductos.vue?vue&type=script&lang=js"
export * from "./ClientInventarioProductos.vue?vue&type=script&lang=js"

import "./ClientInventarioProductos.vue?vue&type=style&index=0&id=222da6eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222da6eb"]])

export default __exports__